import { Product } from "@/services/productService";
import { Content } from "../catalogPage/types";
import { PayLaterOption } from "./payLaterOptions/types";
import { DeliveryScope, DeliveryTimeline } from "./expressDelivery/types";

export type ProductVariant = {
  size: string | null;
  sizeId: number;
  sizeStock: number;
  sortOrder: number | null;
  upc: string;
  sizeShortLabel?: string | null;
  sizeLabel?: string;
};

export type ProductSizes = {
  sizeType: TextAttributeField | EmptyObject;
  variants: ProductVariant[];
}[];

export type SelectedSize = {
  sizeType: TextAttributeField | EmptyObject;
  size: ProductVariant | EmptyObject;
};

export type ProductDetailsLayoutProps = {
  topSections: Content[];
  firstSections: Content[];
  secondSections: Content[];
  language: string;
  productId: number;
  itemDetailWrapperRef: React.RefObject<HTMLInputElement>;
  activeSizeType: TextAttributeField | EmptyObject;
  setActiveSizeType: (sizeType: TextAttributeField) => void;
  selectedSizeFullData: SelectedSize;
  setSelectedSizeFullData: (selectedSize: SelectedSize) => void;
  setShowProductSizeChart: (sizeChart: boolean) => void;
  setShowShippingOptions: (isShow: boolean) => void;
  setSelectedQty: (qty: number) => void;
  selectedQty: number;
  onAddToCartClickHandler: () => void;
  addToCart: (body: AddToCartBody | EmptyObject) => Promise<any>;
  getCartData: () => {};
  item: Product;
  isSuccessBlockOpen: boolean;
  closeSuccessAddedToCartBlock: () => void;
  sameSizeInCartCount: number;
  payLaterOptions: PayLaterOption[];
  deliveryTimelines: DeliveryTimeline[];
  deliveryScope?: DeliveryScope;
  selectedSizeSource?: DeliveryScope.Global | DeliveryScope.Local | null;
  onSizeSelectionHandler: (size: SelectedSize) => void;
  openMultipleSizes: boolean;
  setOpenMultipleSizes: (isOpen: boolean) => void;
  countryId: number;
  subcategory: TextAttributeField & { id: number };
  captionImageURL: string;
  productSizeChart: any[];
  showProductSizeChart: boolean;
  showShippingOptions: boolean;
  goToCart: () => void;
  alertMessage: string;
  setAlertMessage: (value: string) => void;
  isRTL: boolean;
  onSizeSelectionModalClose?: () => void;
};

type AddToCartBody = {
  productId: number;
  quantity: number;
  size: string;
  sizeId: number;
  sizeType: string;
  sizeTypeKey: string;
};

export type ShareInfoProp = {
  pinterestImage: string;
  onMethodClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  hasOverlayTag?: boolean;
};

export type ProductErrorContext = {
  selectSizeFirstError: boolean;
  setSelectSizeFirstError: React.Dispatch<React.SetStateAction<boolean>>;
};

export enum ProductImageVariant {
  Real = "real",
  AI = "ai"
}
